import { render, staticRenderFns } from "./busqueda-institucion.vue?vue&type=template&id=6aa4b91e&"
import script from "./busqueda-institucion.component.ts?vue&type=script&lang=ts&"
export * from "./busqueda-institucion.component.ts?vue&type=script&lang=ts&"
import style0 from "./busqueda-institucion.vue?vue&type=style&index=0&id=6aa4b91e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports